import { useCallback } from "react";
import { useGetRequest } from "../ApiWrappers/useGetRequest";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { v1 } from "src/Utils/ApiVersions";

interface IUpgradeInfo {
    upgradeLicensePackageName: string;
    currentLicensePackageName: string;
    creditAmount: number;
    upgradePackageAmount: number;
    amountDue: number;
    appliedBalance: number;
    currentPackageEndDate: string; 
    upgradeInitiateDate: string; 
    upgradePackageEndDate: string; 
    currency: string;
    taxDescription:string;
    taxableAmount:number;
    totalTax:number;
    upcomingInvoiceId: string;
    upgradeErrorCode: UpgradeErrorCode;
}

export enum UpgradeErrorCode
{
    None = "None",
    CardNotFound = "CardNotFound",
    TaxInfoNotFound = "TaxInfoNotFound",
    PaymentPending = "PaymentPending",
}

export const useGetUpgradeInfo = () => {
    const scope = Config.GetConfigData().auraLicensingService?.scopes[0];
    const baseUrl = Config.GetConfigData().auraLicensingService?.serviceUrl;
    const [getDetails, data, loading, error] = useGetRequest<IUpgradeInfo>();

    const getUpgradeInfo = useCallback((clinicId: string, priceId: string) => {
        if (clinicId && priceId) {
            const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/upgrade/info?newPriceId=${priceId}`;
            getDetails(scope, requestUrl);
        }
    }, [getDetails, scope, baseUrl]);

    return {
        getUpgradeInfo,
        data,
        loading,
        error
    };
};